import { FC } from 'react';
import classNames from 'classnames';
import { AccordionButton } from 'views/Pages/Accordions/AccordionButton';
import { FilterRecipientsSection } from './FilterRecipientsSection';
import { FilterSettingsSection } from './FilterSettingsSection';
import { RecipientOption } from './types';
import { FILTER_SECTIONS, RECIPIENTS_SECTION_INDEX, SETTINGS_SECTION_INDEX } from './constants';

type Props = {
  index: number;
  itemVisible: number;
  savedName?: string;
  recipientOptions: RecipientOption[];
  showsCriteriaNote: boolean;
  isSubmitting: boolean;
  onNext: () => void;
};

export const FilterAccordion: FC<Props> = ({
  index,
  itemVisible,
  savedName,
  recipientOptions,
  showsCriteriaNote,
  isSubmitting,
  onNext,
}) => (
  <div
    className={classNames('accordion-content', {
      'accordion-content--visible': itemVisible === index,
      'accordion-content--hidden': itemVisible !== index,
    })}
  >
    <div className="card">
      <div className="card-body card-body-page-detail">
        {index === SETTINGS_SECTION_INDEX && <FilterSettingsSection savedName={savedName} />}
        {index === RECIPIENTS_SECTION_INDEX && (
          <FilterRecipientsSection
            options={recipientOptions}
            showsCriteriaNote={showsCriteriaNote}
          />
        )}
        {index < FILTER_SECTIONS.length - 1 ? (
          <AccordionButton onClick={onNext}>Next</AccordionButton>
        ) : (
          <AccordionButton type="submit" variant="submit" isSubmitting={isSubmitting}>
            Publish
          </AccordionButton>
        )}
      </div>
    </div>
  </div>
);
